import {
    CardDescription,
    CardList,
    CardListItem,
    CardTitle,
    CardTitleSecondary,
    CardTitleTertiary,
    CardWrapper,
} from './Card.styled';

export interface CardComponentProps {
    alignContent?: React.CSSProperties['justifyContent'];
    children?: React.ReactNode;
    className?: string;
    testId: string;
}

export const Card = ({ children, testId, ...rest }: CardComponentProps) => (
    <CardWrapper {...rest} data-testid={testId}>
        {children}
    </CardWrapper>
);

Card.Description = CardDescription;
Card.List = CardList;
Card.ListItem = CardListItem;
Card.Title = CardTitle;
Card.TitleSecondary = CardTitleSecondary;
Card.TitleTertiary = CardTitleTertiary;
